"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_CATALOG_SUPPLY = void 0;
const gql_1 = require("../../../__generated__/gql");
// clientMutationId is not currently used, but should be a string
exports.CREATE_CATALOG_SUPPLY = (0, gql_1.gql)(`
   mutation CreateCatalogSupply($catalogId: ID!, $uploadId: ID!) {
    supply(supply: {
      source: $uploadId,
      destination: $catalogId,
      clientMutationId: ""
    }) {
      success
      error
    }
  }
`);
